<template>
    <v-dialog v-model="$store.state.paperworkAnalytics.action" max-width="500px" persistent>
        <v-card>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Reason
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon left @click="$store.state.paperworkAnalytics.action = false;">
                    <v-icon>
                        mdi-window-close
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col>
                        <v-combobox label="Select Action" dense :items="actions" :item-text="'Action'"
                            :item-value="'ActionId'" auto-select-first v-model="action" hide-details
                            multiple></v-combobox>
                    </v-col>
                </v-row>
                <v-row justify="end">
                    <v-btn class="mr-4 mb-3" color="success" @click="sendTo(OrderID)">Save</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

import axios from 'axios';
export default {
    props: ['OrderID', 'Actions', 'BolCheckStatus', 'Ord'],
    data: function () {
        return {
            action: null,
            actions: [],
        }
    },
    mounted() {
        this.getActions();
        //this.functionsForMountedHere();
    },
    methods: {
        getActions: function () {
            var str = this.$store;
            axios
                .get('action/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.actions = response.data;
                    const idx = this.actions.findIndex(x => {
                        return x.ActionId == 36;
                    });

                    this.actions.splice(idx, 1);
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        sendTo: async function (orderID) {
            var str = this.$store;
            console.log("sendTo");
            console.log(orderID);
            if (this.action == null) {
                str.dispatch('setSnackbar', {
                    color: 'secondary',
                    text: 'Select a reason'
                });
            } else {
                this.$store.state.isLoading = true;
                var parms = {
                    ActionId: this.action,
                    BolCheckStatusID: this.BolCheckStatus
                }
                console.log(parms);
                await axios
                    .put('paperwork-analytics/multi-action/' + this.OrderID, parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Order successfully updated.'
                        });
                        if (this.Ord != undefined) {
                            if (this.BolCheckStatus == 2) {
                                this.Ord.Status = 'yellow';
                                this.Ord.BolCheckStatusID = this.BolCheckStatus;
                            } else {
                                this.Ord.Status = 'red';
                                this.Ord.BolCheckStatusID = this.BolCheckStatus;
                            }
                            this.Ord.actions = response.data;
                            console.log(this.Ord)
                        }
                        // console.log(this.action);
                        //  var opt = await this.action.filter(x =>{ 
                        //   return x.ActionId == 8 || x.ActionId == 7;
                        //  });
                        var max = await this.seachMaxValue(this.action, 'EditQB');
                        var min = await this.seachMinValue(this.action, 'EditQB');
                        console.log(max, min);

                        str.state.isLoading = false;
                        if (max == 1 && min == 1 || max == 1 && min == 0) {
                            this.$emit('closeEdt');
                            this.Ord.Display = true;
                            this.$store.state.paperworkAnalytics.action = false;
                        } else if (max == 2 && min == 2 || max == 2 && min == 0) {
                            this.$emit('closeEdit2');
                            this.Ord.Display = true;
                            this.$store.state.paperworkAnalytics.action = false;
                        } else if (max == 3 || max == 2 && min == 1) {
                            this.$emit('closeEdt3');
                            this.Ord.Display = true;
                            this.$store.state.paperworkAnalytics.action = false;
                        } else if (max == 4) {
                            const max2 = await this.searchSecondMaxValue(this.action, 'EditQB');
                            console.log(min,max2,max);
                            if (max2 == 1 && min == 1) {
                                console.log("1 Option")
                                this.$emit('closeEdt');
                                this.Ord.Display = true;
                                this.$store.state.paperworkAnalytics.action = false;
                            } else if (max2 == 2 && min == 2) {
                                console.log("2 Option")
                                this.$emit('closeEdit2');
                                this.Ord.Display = true;
                                this.$store.state.paperworkAnalytics.action = false;
                            } else if (min == 3 || max2 == 2 && min == 1) {
                                console.log("3 Option")
                                this.$emit('closeEdt3');
                                this.Ord.Display = true;
                                this.$store.state.paperworkAnalytics.action = false;
                            } else {
                                this.$emit('closeEdt4');
                                this.Ord.Display = true;
                                this.$store.state.paperworkAnalytics.action = false;
                            }
                        } else {
                            this.$emit('closeAct');
                            this.$store.state.paperworkAnalytics.action = false;
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Something is wrong. Please contact the administrator.'
                        });
                    });
            }
        },
        seachMaxValue: function (arr, field) {
            if (arr.length === 0) {
                return undefined;
            }
            let maxValue = arr[0][field];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i][field] > maxValue) {
                    maxValue = arr[i][field];
                }
            }
            return maxValue;
        },
        searchSecondMaxValue: function (arr, field) {
            if (arr.length < 2) {
                return undefined; // No hay suficientes elementos para encontrar el segundo valor más alto
            }
            let max1 = arr[0][field];
            let max2 = arr[1][field];
            // Asegurarse de que max1 sea el valor más grande y max2 el segundo más grande
            if (max1 < max2) {
                [max1, max2] = [max2, max1];
            }
            for (let i = 2; i < arr.length; i++) {
                if (arr[i][field] > max1) {
                    max2 = max1;
                    max1 = arr[i][field];
                } else if (arr[i][field] > max2 && arr[i][field] !== max1) {
                    max2 = arr[i][field];
                }
            }
            return max2;
        },
        seachMinValue: function (arr, field) {
            if (arr.length === 0) {
                return undefined;
            }
            let minValue = arr[0][field];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i][field] < minValue) {
                    minValue = arr[i][field];
                }
            }
            return minValue;
        }
    }
}
</script>